/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppLabTeacherExplanation } from '../../models/app-lab-teacher-explanation';

export interface AppControllerFindTeacherExplanation$Params {
  appId: string;
  language: string;
}

export function appControllerFindTeacherExplanation(http: HttpClient, rootUrl: string, params: AppControllerFindTeacherExplanation$Params, context?: HttpContext): Observable<StrictHttpResponse<AppLabTeacherExplanation>> {
  const rb = new RequestBuilder(rootUrl, appControllerFindTeacherExplanation.PATH, 'get');
  if (params) {
    rb.path('appId', params.appId, {});
    rb.path('language', params.language, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AppLabTeacherExplanation>;
    })
  );
}

appControllerFindTeacherExplanation.PATH = '/app/teacherExplanation/{language}/{appId}';
